import { apiSlice, createBodyMutation } from './baseApi';
import { DEFAULT_PAGE_LIMIT } from '@constants/appDefaults';

export const accountCodeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAccountCodes: builder.query({
      query: (arg) => {
        const { companyId, currentAccountCodeId } = typeof arg === 'object' ? arg : { companyId: arg };
        return {
          url: '/account-codes/get-all-account-codes', method: 'POST',
          body: { company_id: companyId, picker: true, limit: 500,
            ...(currentAccountCodeId && { current_account_code_id: currentAccountCodeId }) },
        };
      },
      transformResponse: (response, _meta, arg) => {
        const current = typeof arg === 'object' ? arg.currentAccountCodeId : undefined;
        return (response?.accountCodes || [])
          .filter(code => code.active !== false && !code.is_group || code._id === current)
          .map(code => ({ ...code, name: `${code.code} - ${code.description}`, value: code._id,
            disabled: code.active === false || code.is_group === true }));
      },
      providesTags: ['AccountCodes'],
    }),
    getAccountCodesList: builder.query({
      query: ({ companyId, page = 1, limit = DEFAULT_PAGE_LIMIT, search }) => ({
        url: '/account-codes/get-all-account-codes',
        method: 'POST',
        body: { company_id: companyId, page, limit, ...(search != null && search !== '' && { search }) },
      }),
      transformResponse: (response) => ({
        accountCodes: response?.accountCodes || [],
        totalPages: response?.totalPages ?? 1,
      }),
      providesTags: ['AccountCodes'],
    }),
    getAccountCodeAmounts: builder.query({
      query: ({ companyId, dateRange }) => ({
        url: '/account-codes/get-all-account-code-amounts',
        method: 'POST',
        body: { company_id: companyId, ...(dateRange && { dateRange }) },
      }),
      transformResponse: (response) => ({
        expensesMap: response?.expensesMap || {},
        investmentsMap: response?.investmentsMap || {},
        serviceCostsMap: response?.serviceCostsMap || {},
        invoiceRevenuesMap: response?.invoiceRevenuesMap || {},
      }),
      providesTags: ['AccountCodeAmounts'],
    }),
    addAccountCode: builder.mutation(
      createBodyMutation({ url: '/account-codes/add-new-account-code', invalidatesTags: ['AccountCodes'] })
    ),
    editAccountCode: builder.mutation(
      createBodyMutation({ url: '/account-codes/edit-account-code', invalidatesTags: ['AccountCodes'] })
    ),
    deleteAccountCode: builder.mutation(
      createBodyMutation({ url: '/account-codes/delete-account-code', invalidatesTags: ['AccountCodes'] })
    ),
  }),
});
